import { render, staticRenderFns } from "./Events.vue?vue&type=template&id=31f9cefe&scoped=true&"
import script from "./Events.vue?vue&type=script&lang=js&"
export * from "./Events.vue?vue&type=script&lang=js&"
import style0 from "./Events.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Events.vue?vue&type=style&index=1&id=31f9cefe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f9cefe",
  null
  
)

export default component.exports